module.exports = __webpack_public_path__ + "static/media/38.8c6cc018.jpg";